
export default {
  filteredPekerjaans: state => state.pekerjaans.filter((pekerjaan) => {
    return (state.pekerjaan_filter === 'starred' ? pekerjaan.isStarred : state.pekerjaan_filter === pekerjaan.pekerjaanFolder || pekerjaan.labels.includes(state.pekerjaan_filter)) && (pekerjaan.sender_name.toLowerCase().includes(state.pekerjaanSearchQuery.toLowerCase()) || pekerjaan.sender.toLowerCase().includes(state.pekerjaanSearchQuery.toLowerCase()) || pekerjaan.subject.toLowerCase().includes(state.pekerjaanSearchQuery.toLowerCase()) || pekerjaan.message.toLowerCase().includes(state.pekerjaanSearchQuery.toLowerCase()))
  }),
  getPekerjaan: state => (pekerjaanId) => 
  state.pekerjaans.find((pekerjaan) => pekerjaan.id === pekerjaanId)
}
